import { Link } from "react-router-dom";
import { ORG } from "@/lib/constants";

export function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-slate-950 text-slate-300">
      <div className="tricolor-bar h-1 w-full" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center w-10 h-10 rounded-lg bg-white p-1">
              <img src={ORG.logo} alt={`${ORG.name} logo`} className="w-full h-full" />
            </span>
            <span className="font-display font-extrabold text-lg text-white">Healthy India Pledge Wall</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            A nationwide campaign uniting medical professionals for a healthier India. August 8–14, 2026.
          </p>
          <p className="mt-3 text-sm font-semibold text-[#FF9933]">An initiative by {ORG.name}</p>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pledge" className="hover:text-[#FF9933] transition-colors">Take the Pledge</Link></li>
            <li><Link to="/wall" className="hover:text-[#FF9933] transition-colors">Live Pledge Wall</Link></li>
            <li><Link to="/retrieve" className="hover:text-[#FF9933] transition-colors">Retrieve Certificate</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#FF9933] transition-colors">Admin Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Contact</h4>
          <p className="text-sm text-slate-400 leading-relaxed">
            Campaign Organizers<br />
           
            Supporting the Asia Book of Records attempt.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © 2026 {ORG.name} · Healthy India Pledge Wall. Self-declared campaign for medical professionals.
      </div>
    </footer>
  );
}
